exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.substrate[data-v-5791b66c] {\r\n  width: 100%;\r\n  height: 100vh;\r\n  background-color: rgba(0, 0, 0, 0.7);\r\n  position: absolute;\r\n  z-index: 10000;\n}\n.substrate input[data-v-5791b66c] {\r\n  margin: 0 auto;\r\n  position: absolute;\r\n  bottom: 30%;\r\n  width: 200px;\r\n  height: 50px;\r\n  background-color: #f5f636;\r\n  outline: none;\r\n  border: 0px;\r\n  border-radius: 20px;\r\n  left: calc(50% - 100px);\r\n  font-size: 18px;\n}\n.substrate div[data-v-5791b66c] {\r\n  color: #fff;\r\n  width: 250px;\r\n  position: absolute;\r\n  left: calc(50% - 125px);\r\n  font-size: 20px;\r\n  bottom: 5%;\n}\n.policy[data-v-5791b66c] {\r\n  overflow: auto;\r\n  height: 95vh;\r\n  padding: 25px;\n}\n.policy h2[data-v-5791b66c] {\r\n  text-align: center;\n}\r\n/* .substrate div a{\r\n    color:#3096BC\r\n  } */\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-5791b66c","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/components/app.vue
// module id = 612
// module chunks = 0